export function hasValue(value: any): Error | undefined {
  const error = new Error("Required");
  const type = Array.isArray(value) ? "array" : typeof value;

  switch (type) {
    case "number":
      if (value !== 0 && !value) {
        return error;
      }
      break;
    case "boolean":
      if (value === false) return error;
      break;
    case "array":
      if (!value.length) {
        return error;
      }
      break;
    default:
      if (!value) {
        return error;
      }
      break;
  }
}

export function hasValueWithCustomError(
  value: any,
  errorMessage: string
): Error | undefined {
  switch (typeof value) {
    case "number":
      if (value !== 0 && !value) {
        return new Error(errorMessage);
      }
      break;
    case "boolean":
      return;
    default:
      if (!value) {
        return new Error(errorMessage);
      }
      break;
  }
}
